import {
    ExamList,
    FilteredExamStatus,
} from '../../api/ApiClient';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import moment from 'moment';
import { IFilterPart } from 'components/models';

const initialState: IExamsState = {
    waitingForApprovalExams: null,
    examsList: null,
};

const exams = createModel({
    state: initialState,
    reducers: {
        setWaitingForApprovalExams(state: IExamsState, waitingForApprovalExams: IExamsState['waitingForApprovalExams']): IExamsState {
            return { ...state, waitingForApprovalExams };
        },
        setExams(state: IExamsState, examsList: IExamsState['examsList']): IExamsState {
            return { ...state, examsList };
        },
    },
    effects: (dispatch: any) => ({
        async getExamsAsync(payload: IGetExamsList) {
            const examsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExams(
              payload.qualificationIds,
              payload.attestationSubCommissionIds,
              payload.accreditationCenterIds,
              payload.filteredExamStatus,
              payload.from,
              payload.to,
              payload.page,
              payload.pageSize,
              payload.sortOrder,
              payload.sortField,
            ));
            this.setExams(examsList);
        },

        async fetchWaitingForApprovalExams(payload: IFilterPart = {}) {
            const waitingForApprovalExams = await apiConnector.execApi(dispatch, api => api.getWaitingForApprovalExams(
              payload.page,
              payload.pageSize,
              payload.sortOrder,
              payload.sortField,
            ));

            this.setWaitingForApprovalExams(waitingForApprovalExams);
        },
    }),
});

export interface IGetExamsList {
    qualificationIds?: string[];
    attestationSubCommissionIds?: string[];
    accreditationCenterIds?: string[];
    acIds?: string[];
    filteredExamStatus?: FilteredExamStatus | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

interface IExamsState {
    waitingForApprovalExams: ExamList | null;
    examsList: ExamList | null;
}

export default exams;
